
import { CommonApiResponse } from "../../../Controllers/Types/ApiResponse";
import { baseURL } from "../../ApiConstant";

// Aplication Check List Apis

export const applicationCheckListGetApi = async (seriviceId : number): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(`${baseURL}/api/application-checklist-data/${seriviceId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200, data: data };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
}

export const applicationChecklistCreateAPI = async (folder_id: number, title: string, instruction_date: string | null, expected_date: string | null, status: string, path: File): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;

        /* create form data */
        const formData = new FormData();
        formData.append('folder_id', folder_id.toString());
        formData.append('title', title);
        if (instruction_date) {
            formData.append('instruction_date', instruction_date); 
        }

          if (expected_date) {
            formData.append('expected_date', expected_date); 
        }
        formData.append('status', status); 
        if (path) {
            formData.append('path', path);
        }

        const response = await fetch(`${baseURL}/api/application-checklist/create`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: formData,

        });
        

        const data = await response.json();        

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};

export const applicationChecklistUpdateAPI = async (id: number, title: string, instruction_date: string | null,  expected_date: string | null,  status: string, path: File): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;

        /* create form data */
        const formData = new FormData();
        formData.append('title', title);
        if (instruction_date) {
            formData.append('instruction_date', instruction_date); 
        }


         if (expected_date) {
            formData.append('expected_date', expected_date); 
        }

        formData.append('status', status); 
        if (path) {
            formData.append('path', path);
        }

        const response = await fetch(`${baseURL}/api/application-checklist/update/${id}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: formData,

        });
        

        const data = await response.json();        

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};

export const applicationChecklistDeleteAPI = async (id: number): Promise<CommonApiResponse> => {
    try {        
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/application-checklist/delete/${id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            }
        });
        
        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};


// commencementChecklist
export const commencementChecklistGetApi = async (seriviceId : number): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(`${baseURL}/api/commencement-checklist-data/${seriviceId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200, data: data };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
}

export const commencementChecklistCreateAPI = async (folder_id: number, title: string, instruction_date: string | null, expected_date: string | null, status: string, path: File): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;

        /* create form data */
        const formData = new FormData();
        formData.append('folder_id', folder_id.toString());
        formData.append('title', title);
        if (instruction_date) {
            formData.append('instruction_date', instruction_date); 
        }

          if (expected_date) {
            formData.append('expected_date', expected_date); 
        }
        formData.append('status', status); 
        if (path) {
            formData.append('path', path);
        }

        const response = await fetch(`${baseURL}/api/commencement-checklist/create`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: formData,

        });
        

        const data = await response.json();        

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};

export const commencementChecklistUpdateAPI = async (id: number, title: string, instruction_date: string | null,  expected_date: string | null,  status: string, path: File): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;

        /* create form data */
        const formData = new FormData();
        formData.append('title', title);
        if (instruction_date) {
            formData.append('instruction_date', instruction_date); 
        }


         if (expected_date) {
            formData.append('expected_date', expected_date); 
        }

        formData.append('status', status); 
        if (path) {
            formData.append('path', path);
        }

        const response = await fetch(`${baseURL}/api/commencement-checklist/update/${id}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: formData,

        });
        

        const data = await response.json();        

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};

export const commencementChecklistDeleteAPI = async (id: number): Promise<CommonApiResponse> => {
    try {        
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/commencement-checklist/delete/${id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            }
        });
        
        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};


// drawingChecklist
export const drawingChecklistGetApi = async (seriviceId : number): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;

        const response = await fetch(`${baseURL}/api/drawing-checklist-data/${seriviceId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
        });

        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200, data: data };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
}

export const drawingChecklistCreateAPI = async (folder_id: number, title: string,  status: string, path: File): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;

        /* create form data */
        const formData = new FormData();
        formData.append('folder_id', folder_id.toString());
        formData.append('title', title);
    
        formData.append('status', status); 
        if (path) {
            formData.append('path', path);
        }

        const response = await fetch(`${baseURL}/api/drawing-checklist/create`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: formData,

        });
        

        const data = await response.json();        

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};

export const drawingChecklistUpdateAPI = async (id: number, title: string,   status: string, path: File): Promise<CommonApiResponse> => {
    try {
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;

        /* create form data */
        const formData = new FormData();
        formData.append('title', title);
       
        formData.append('status', status); 
        if (path) {
            formData.append('path', path);
        }

        const response = await fetch(`${baseURL}/api/drawing-checklist/update/${id}`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            },
            body: formData,

        });
        

        const data = await response.json();        

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};

export const drawingChecklistDeleteAPI = async (id: number): Promise<CommonApiResponse> => {
    try {        
        const token = localStorage.getItem('token');
        const FULL_TOKEN = `Bearer ${token}`;
        const response = await fetch(`${baseURL}/api/drawing-checklist/delete/${id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': FULL_TOKEN
            }
        });
        
        const data = await response.json();

        if (response.status === 200) {
            return { status: true, statusCode: 200 };
        } else if (response.status === 401) {
            return { status: false, statusCode: 401, massage: "Unauthorized" };
        } else if (response.status === 422) {
            return { status: false, statusCode: 422, errors: data['errors'], massage: "Body error" };
        } else if (response.status === 404) {
            return { status: false, statusCode: 404, massage: "Not found" };
        } else {
            return { status: false, statusCode: 500, massage: "Error" };
        }

    } catch (error) {
        throw error;
    }
};